import React from 'react';
import { generateClient } from 'aws-amplify/api';
import { getUrl } from 'aws-amplify/storage';
import { deleteEnrollment, updateEnrollment } from '../graphql/mutations';
import { FaTrashAlt, FaImage, FaCheckCircle, FaUserGraduate } from 'react-icons/fa';

const EnrollmentManager = ({ enrollments, onUpdate }) => {
    const client = generateClient();

    const handleDelete = async (id) => {
        if (!window.confirm("¿ELIMINAR ACCESO? El usuario ya no verá este curso en su panel. Esta acción es irreversible.")) return;
        try {
            await client.graphql({
                query: deleteEnrollment,
                variables: { input: { id } },
                authMode: 'userPool',
            });
            alert("✅ Acceso eliminado del panel del usuario.");
            onUpdate(); 
        } catch (e) {
            console.error("Error al eliminar:", e);
            alert("No se pudo eliminar el registro.");
        }
    };

    // --- CORRECCIÓN DE LA RUTA DEL RECIBO (MANTENIENDO TU LÓGICA COMPLETA) ---
    const handleViewReceipt = async (key) => {
        try {
            if (!key || key === "n/a" || key === "N/A") return alert("No hay comprobante registrado.");
            
            // 1. Limpiamos la key de cualquier prefijo 'public/' duplicado
            const cleanKey = key.replace('public/', '');
            
            // 2. CONSTRUIMOS LA RUTA REAL
            const folder = cleanKey.includes('course-receipts/') ? '' : 'course-receipts/';
            const finalPath = `public/${folder}${cleanKey}`;
            
            console.log("Intentando abrir recibo en:", finalPath); 

            const signedUrl = await getUrl({ 
                path: finalPath,
                options: {
                    validateObjectExistence: true 
                }
            });
            window.open(signedUrl.url.toString(), '_blank');
        } catch (error) {
            console.error("Error S3:", error);
            alert("Error al cargar la imagen. El archivo no existe en: course-receipts/");
        }
    };

    const handleApprove = async (id) => {
        try {
            await client.graphql({
                query: updateEnrollment,
                variables: { 
                    input: { 
                        id: id, 
                        status: "APROBADO" // UNICO CAMBIO: De COMPLETADO a APROBADO para que el perfil lo reconozca
                    } 
                },
                authMode: 'userPool'
            });
            alert("✅ Inscripción aprobada. El curso se ha activado en el panel del usuario.");
            onUpdate();
        } catch (e) { 
            console.error("Error al actualizar:", e);
            alert("Error al actualizar."); 
        }
    };

    return (
        <div className="admin-container-pro">
            <div className="admin-header-main" style={{backgroundColor: '#001f3f'}}>
                <div className="header-text">
                    <h3 style={{color: '#D4AF37'}}><FaUserGraduate /> Control de Alumnos e Inscripciones</h3>
                    <p>Gestión de accesos a la Academia (Elimina aquí para quitar cursos de ejemplo)</p>
                </div>
                <span className="badge-count">{enrollments.length} Inscritos</span>
            </div>
            
            <div className="table-wrapper">
                <table className="legal-table">
                    <thead>
                        <tr>
                            <th>Fecha</th>
                            <th>Alumno (Email)</th>
                            <th>Curso</th>
                            <th>Monto</th>
                            <th>Estado</th>
                            <th>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {enrollments.map((enr) => (
                            <tr key={enr.id}>
                                <td>{enr.enrollmentDate ? new Date(enr.enrollmentDate).toLocaleDateString() : 'N/A'}</td>
                                <td><strong>{enr.userEmail || enr.customerEmail}</strong></td>
                                <td>{enr.courseTitle}</td>
                                <td>
                                    ${enr.amountUSD} 
                                    <br/>
                                    <small>{enr.amountBS} Bs.</small>
                                </td>
                                <td>
                                    <span className={`status-pill ${enr.status}`}>{enr.status}</span>
                                </td>
                                <td>
                                    <div style={{display: 'flex', gap: '8px'}}>
                                        <button 
                                            className="btn-mini-receipt" 
                                            // Mantenemos tu lógica de prioridad de campos para la imagen
                                            onClick={() => handleViewReceipt(enr.receiptKey || enr.category)} 
                                            title="Ver Pago"
                                        >
                                            <FaImage />
                                        </button>
                                        
                                        {/* Cambiado para ocultar el botón si ya está APROBADO */}
                                        {enr.status !== 'APROBADO' && (
                                            <button 
                                                className="btn-price" 
                                                style={{backgroundColor: '#28a745', border: 'none', color: 'white', padding: '5px 10px', borderRadius: '4px', cursor: 'pointer'}} 
                                                onClick={() => handleApprove(enr.id)} 
                                                title="Aprobar Acceso"
                                            >
                                                <FaCheckCircle />
                                            </button>
                                        )}

                                        <button 
                                            className="btn-delete-legal" 
                                            onClick={() => handleDelete(enr.id)} 
                                            title="Eliminar Acceso y borrar del panel del usuario"
                                        >
                                            <FaTrashAlt color="#ff4d4d" />
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default EnrollmentManager;